module.exports = __webpack_public_path__ + "img/icon_autoatendimento_home.4f610b45.svg";